export default "__VITE_PUBLIC_ASSET__02bee001__"